import React from 'react';
import styled from 'styled-components/macro';

type Props = {
  className?: string;
  show?: boolean;
  tagline?: string;
};

export const TaglineSection = (props: Props) => {
  const { className = '', show = true, tagline = '' } = props;

  if (!show || tagline === '') return null;

  return (
    <StyledTaglineSection className={`${className} tagline-wrapper`}>
      <TaglineText className="tagline">{tagline}</TaglineText>
    </StyledTaglineSection>
  );
};

const StyledTaglineSection = styled.section`
  && {
    margin: 0 auto;
    padding: 0;
  }
`;

const TaglineText = styled.div`
  && {
    font-size: 1.6rem;
    font-weight: 100;
    line-height: 48px;
    letter-spacing: 10px;
    text-align: center;
    text-transform: uppercase;

    @media (max-width: 767px) {
      line-height: 26px;
      padding-top: 4px;
      padding-bottom: 4px;
      font-size: 0.7rem;
    }
  }
`;
